import { useMemo } from 'react'
import { useThreatProfilesTokenClaims } from '../ThreatProfiles/useThreatProfilesTokenClaims'

const entitlementMap = [
  ['gtiStandard', 'GTI_STANDARD'],
  ['gtiEnterprise', 'GTI_ENTERPRISE'],
  ['gtiEnterprisePlus', 'GTI_ENTERPRISE_PLUS'],
]

export const useGTISubscription = () => {
  const claims = useThreatProfilesTokenClaims()
  const isl = useMemo(() => {
    return claims.isl || []
  }, [claims])

  const entitlements = useMemo(() => {
    return entitlementMap.reduce((acc, [key, claim]) => {
      acc[key] = isl.indexOf(claim) > -1

      return acc
    }, {})
  }, [isl])

  const isStandard = entitlements.gtiStandard
  const isEnterprise = !isStandard && entitlements.gtiEnterprise
  const isEnterprisePlus = !isStandard && !isEnterprise && entitlements.gtiEnterprisePlus
  const isAdmin = claims?.role?.includes('sso.customer.admin')

  return {
    isStandard,
    isEnterprise,
    isEnterprisePlus,
    isAdmin
  }
}
